import { Interval } from '../lib/interval'
import { Easing } from '../lib/easing'

//handle all animated scrolling here
export default function initializeScroll() {
    var elements = []
    const scrollHrefs = [...document.querySelectorAll('[href*="#"]')]
    const shouldScroll = [...document.querySelectorAll('*[id^="scrollto-"]')]

    shouldScroll[0].classList.add('active');

    var currentSection = 0
    var offsetTops = []

    function onScroll(event) {
        let closestDistance = Infinity;
        let closestIndex = 0;
        const scrollY = window.scrollY || document.body.scrollTop || pageYOffset;

        for (const [index, offsetTop] of offsetTops.entries()) {
            const distance = Math.abs(offsetTop - scrollY);

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        }

        if (currentSection != closestIndex) {
            shouldScroll[currentSection].classList.remove('active');
            shouldScroll[closestIndex].classList.add('active');
            currentSection = closestIndex;
        }
    }

    function onResize() {
        offsetTops = shouldScroll.map(function (element) {
            const id = element.id.slice(9, element.id.length)
            const target = document.querySelector(`#${id}`)
            return findOffsetTop(target)
        })
    }

    if (!shouldScroll || !scrollHrefs) {
        return
    }
    for (let i = 0; i < scrollHrefs.length; i++) {
        const href = scrollHrefs[i]
        elements.push(href)
    }
    for (let i = 0; i < shouldScroll.length; i++) {
        const element = shouldScroll[i];
        elements.push(element)
    }

    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];

        element.addEventListener('click', (e) => {
            e.preventDefault()

            if (element.id.includes('scrollto-')) {
                let id = element.id.slice(9, element.id.length)

                scroll(id, element)
            } else if (element.href) {
                let href = element.href.substring(element.href.lastIndexOf('/') + 1)
                href = href.replace('#', '')

                scroll(href, element)
            } else {
                console.error("element had no valid href nor valid id: ", element)
            }

            function scroll(toTarget, element) {
                // basicly, if the page is not home, be a normal menu item.
                if (toTarget == 'top' && window.location.href.substring(window.location.href.lastIndexOf('/') + 1) !== '' && !element.classList.contains('menu-backtotop')) {
                    if (e.currentTarget.children[0].href) {
                        window.location.href = e.currentTarget.children[0].href
                    } else {
                        window.location.href = '/'
                    }
                    return
                }
                if ((toTarget != 'top' && window.location.href.substring(window.location.href.lastIndexOf('/') + 1) !== '' && !element.classList.contains('menu-backtotop')) || window.location.href.match(/([^\/]*)\/*$/)[1] === 'privacy') {
                    let x = e.currentTarget.children[0].href
                    if (x) {
                        let z = x.substring(x.lastIndexOf('/') + 1)
                        x = x.replace(z, "")
                        var c
                        if (z) { c = '#' + z }
                        window.location.href = x + c
                    } else {
                        window.location.href = '/'
                    }
                    return
                }

                const target = document.querySelector(`#${toTarget}`)
                const headerHeight = document.querySelector('header').offsetHeight

                if (target) {
                    let y = target.offsetTop
                    scrollToY(y - headerHeight)
                } else {
                    scrollToY(0)
                }
            }
        })
    }

    function both() {
        onResize()
        onScroll()
    }

    document.addEventListener('scroll', onScroll)
    addEventListener('resize', both)
    both()
}

const scrollToY = function () {
    let intrvl = new Interval({ duration: 800 }, function (pos) {
        const ease = Easing.calc(pos, Easing.InOut, Easing.Expo);
        const position = Math.mix(this.begin, this.end, ease);
        scrollTo(0, position);
    })
    intrvl.stop();

    return function scrollToY(y) {
        intrvl.stop()
        intrvl.begin = window.scrollY || pageYOffset || document.body.offsetTop
        intrvl.end = y
        intrvl.start()
    }
}()

function findOffsetTop(element) {
    let y = element.offsetTop
    while ((element = element.parentNode) && 'offsetTop' in element) {
        y += element.offsetTop + 116
    }
    return y;
}

Math.mix = Math.mix || function mix(from, to, at) {
    return from + ((to - from) * at)
}